import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator, ValidatorFn } from '@angular/forms';

/** Returns true if control matches the regex*/
// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function regexValidator(nameRe: RegExp): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const validation = nameRe.test(control.value);

    return validation ? null : { validInsightRegex: { value: control.value } };
  };
}

@Directive({
  selector: '[appValidInsightRegex]',
  providers: [{ provide: NG_VALIDATORS, useExisting: ValidatorDirective, multi: true }]
})
export class ValidatorDirective implements Validator {
  @Input('appValidInsightRegex') public validInsightRegex = '';

  public validate(control: AbstractControl): ValidationErrors | null {
    return this.validInsightRegex ? regexValidator(new RegExp(this.validInsightRegex, 'i'))(control) : null;
  }
}

/*
Copyright Google LLC. All Rights Reserved.
Use of this source code is governed by an MIT-style license that
can be found in the LICENSE file at https://angular.io/license
*/
